// A React remount boundary, not authorization. Server reads and writes still
// check current identity/account scope. Never use a rep filter or credential.
export function workspaceIdentityKey(user, status) {
  const scalar = value => typeof value === 'string' || typeof value === 'number' ? String(value) : null
  const id = scalar(user?.id)
  const book = Array.isArray(user?.book) ? user.book.map(item => scalar(item?.id ?? item)).filter(Boolean).sort() : null
  return JSON.stringify(['workspace-identity-v1', scalar(status), id, scalar(user?.role), scalar(user?.lane), book, scalar(user?.authorizationRevision ?? user?.sessionRevision)])
}
